import { NgModule } from '@angular/core';
import { DomainApiService } from './domain.service';

@NgModule({
    providers: [DomainApiService],
})
export class DomainApiModule {
}
